// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.yHoQM{display:flex;flex-direction:column;align-items:center;width:100%;max-width:600px;margin:0 auto;padding:0 24px;gap:24px}.PacRX{align-items:center;text-align:center;gap:8px}.mmhl4{width:100%}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `yHoQM`,
	"titleContainer": `PacRX`,
	"input": `mmhl4`
};
export default ___CSS_LOADER_EXPORT___;
